import { useEffect } from 'react';
export const useAutoScroll = widgetRef => {
  const scrollingDivRef = document.querySelector('[data-hook="scrollableChatElement"]');
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (widgetRef.current) {
        if (widgetRef.current.offsetHeight > 80) {
          if (scrollingDivRef) {
            scrollingDivRef.scrollTop = scrollingDivRef.scrollHeight;
          }
        }
      }
    });
    const currentElement = widgetRef.current;
    if (currentElement) {
      resizeObserver.observe(currentElement);
    }
    return () => {
      if (currentElement) {
        resizeObserver.unobserve(currentElement);
      }
    };
  }, [widgetRef]);
};
//# sourceMappingURL=useAutoScroll.js.map